module.exports = __webpack_public_path__ + "static/media/banner3b.b65ae176.svg";